export default __webpack_public_path__ + "static/1-303017f616264a8727f22dc4c4cea849.png";